import { render, staticRenderFns } from "./ActivityDrawer.vue?vue&type=template&id=88b85788&"
import script from "./ActivityDrawer.vue?vue&type=script&lang=js&"
export * from "./ActivityDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports